export interface Review {
  id: string;
  title: string;
  excerpt: string;
  cover: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  dramaId: string;
  quote: string;
  content: string[];
}

export const reviews: Review[] = [
  {
    id: 'neon-emotional-fable',
    title: '《深夜霓虹》：都市孤岛上的情感寓言',
    excerpt: '在短剧普遍追求反转与爽感的当下，《深夜霓虹》选择用安静的方式讲述一个关于距离的故事，反而显得格外动人。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20moody%20city%20at%20night%20seen%20through%20rain%20on%20glass%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20neon%20reflections%2C%20film%20grain%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=review-neon-01&orientation=landscape',
    author: '影评人 · 方舟',
    date: '2024-11-20',
    readTime: '8分钟',
    tags: ['情感', '都市', '剧集解读'],
    dramaId: 'late-night-neon',
    quote: '真正的孤独，不是没有人陪，而是有人陪的时候，你依然说不出那句话。',
    content: [
      '在短剧普遍追求高密度反转与即时爽感的当下，《深夜霓虹》显得有些"不合时宜"。它几乎没有强情节冲突，而是把镜头长时间地停留在雨夜的窗、沉默的对话和未发送的消息上。可正是这种克制，让它成为近期最值得回看的一部都市情感短剧。',
      '剧集以午夜电台为叙事锚点，主播沈川的每一通来电，都是一个无处安放的心事。导演顾长风用大量留白制造出一种"被城市包裹的孤独感"——霓虹越亮，人越显得渺小。这种视觉与情绪的反差，构成了整部剧的底色。',
      '林澈的表演是这部剧的骨架。他没有用太多台词去解释角色，而是依赖停顿、眼神和几乎不易察觉的呼吸变化。当沈川终于面对那段被封存的关系时，观众感受到的不是爆发，而是长久的疲惫与释然。',
      '值得一提的是，剧集在成人向题材的处理上保持了难得的体面。它不回避成年人的欲望与软弱，却始终用克制的方式呈现，让情感而非猎奇成为核心。这种分寸感，恰恰是很多同类作品所缺少的。',
      '如果说短剧的黄金法则是"三分钟抓住观众"，那么《深夜霓虹》给出了另一种答案：真正的吸引力，来自情绪的真实。它不急着取悦你，而是邀请你停下来，听一听那些深夜里的沉默。',
    ],
  },
  {
    id: 'golden-three-minutes',
    title: '短剧叙事的黄金三分钟：节奏是如何炼成的',
    excerpt: '短剧不是长剧的缩减版。它的节奏逻辑、信息密度与情绪曲线，都遵循着一套完全不同的规则。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20arrangement%20of%20glowing%20film%20frames%20in%20dark%20space%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20light%20streaks%2C%20film%20grain%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=review-pace-01&orientation=landscape',
    author: '特约评论 · 苏黎',
    date: '2024-10-30',
    readTime: '10分钟',
    tags: ['行业观察', '叙事', '剧集解读'],
    dramaId: 'red-lip-contract',
    quote: '短剧的每一秒都在欠观众一个期待，节奏就是把这份期待不断延后的艺术。',
    content: [
      '很多人以为短剧只是"把长剧剪短"，但真正优秀的短剧创作者会告诉你：这是两套完全不同的语言。长剧可以慢慢铺陈，短剧必须在开场三分钟之内让观众明白——这是一个什么故事，我为什么要看下去。',
      '所谓"黄金三分钟"，本质是信息密度与情绪钩子的平衡。信息太少，观众不知道发生了什么；信息太满，观众又来不及共情。优秀的短剧往往在前三分钟只做一件事：建立一个足够清晰的人物处境。',
      '节奏的真正秘密在于"期待管理"。每一次情节推进，都在给观众一个未兑现的承诺；而每一次兑现，又埋下新的悬念。当这套机制运转顺畅时，观众就会产生"再看一集"的本能。',
      '值得注意的是，成人向短剧对节奏的要求更高。因为题材本身带有情绪门槛，如果节奏失控，很容易滑向猎奇或说教。只有把张力建立在人物的真实动机之上，节奏才有意义。',
      '说到底，短剧不是"更快"，而是"更准"。它考验的不是创作者的耐心，而是判断力——知道哪一秒可以删，哪一秒必须留。',
    ],
  },
  {
    id: 'rose-women-portraits',
    title: '《玫瑰公寓》中的女性群像：各自的屋檐与秘密',
    excerpt: '三个女人，一栋公寓，无数个无法言说的夜晚。这部剧最动人的，是它对"不完美"的温柔。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20dim%20elegant%20lounge%20with%20a%20red%20rose%20and%20warm%20amber%20light%2C%20deep%20charcoal%20and%20burgundy%20tones%2C%20film%20grain%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=review-rose-01&orientation=landscape',
    author: '影评人 · 林知夏',
    date: '2023-11-12',
    readTime: '7分钟',
    tags: ['女性', '群像', '剧集解读'],
    dramaId: 'rose-apartment',
    quote: '她们不是彼此的答案，却成了彼此唯一的听众。',
    content: [
      '《玫瑰公寓》把镜头对准了一栋老式公寓里的三个女人。她们年龄不同、处境不同，却共享着同一种难以启齿的孤独。导演何曼没有把她们写成"完美女性"，反而大方地展示她们的虚荣、软弱与算计。',
      '正是这种"不完美"，让角色有了呼吸感。观众不需要仰视她们，也不会轻易俯视她们，而是在某个瞬间突然发现：她们身上的挣扎，也是我们自己的。',
      '三人之间的关系处理得极为细腻。她们互相试探、互相伤害，也互相拯救。那封没有署名的信，像一根针，把三条各自为政的生命线缝在了一起。',
      '剧集对成人向情感的呈现依然保持了分寸，欲望不被回避，也不被放大。它更关心的是：当一个人在深夜里卸下所有伪装，她究竟想要什么。',
      '如果说大多数女性群像剧在讨论"如何活得更好"，那么《玫瑰公寓》讨论的是"如何承认活得不好"。这份诚实，是它最大的勇气。',
    ],
  },
  {
    id: 'dangerous-boundaries',
    title: '从《危险关系》看成人向题材的边界',
    excerpt: '噱头与深度之间，只隔着一次真诚的凝视。这部剧证明了，成人向不等于低俗，而可以是成熟的代名词。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20elegant%20glass%20of%20red%20wine%20on%20a%20dark%20table%20with%20two%20empty%20chairs%2C%20deep%20charcoal%20and%20crimson%20tones%2C%20film%20grain%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=review-danger-01&orientation=landscape',
    author: '特约评论 · 陈默',
    date: '2024-08-01',
    readTime: '9分钟',
    tags: ['题材探讨', '情感', '剧集解读'],
    dramaId: 'dangerous-liaison',
    quote: '成人向的真正前提不是尺度，而是复杂——承认情感里有算计，也有真心。',
    content: [
      '《危险关系》的片名本身就带着挑衅意味，但它真正讨论的，并不是"危险"本身，而是成年人在情感关系里的自我博弈。这是一部愿意把角色写复杂、也愿意让观众不舒服的作品。',
      '两位主角势均力敌，谁先动心谁就输的设定，看似是套路，实则是对亲密关系中权力结构的隐喻。导演用大量的对峙镜头，让"靠近"变成一场需要勇气的冒险。',
      '值得肯定的是，剧集在"成人向"的标签下，始终保持对人物的尊重。它不靠猎奇镜头吸引眼球，而是用情绪的暗流制造张力。欲望存在，但它服务于人物，而非凌驾于人物之上。',
      '剧集的争议也正来自这份复杂——有观众认为它不够"爽"，也有观众觉得它过于冷静。但恰恰是这种不讨好，让它具备了短剧里少见的讨论价值。',
      '真正成熟的成人向作品，从不把观众当猎物。它更愿意把观众当成同样有经历、有判断力的成年人。《危险关系》做到了这一点。',
    ],
  },
  {
    id: 'neon-color-stories',
    title: '霓虹美学：色彩如何替角色说话',
    excerpt: '当对白无法抵达情绪深处时，颜色会替人物开口。这期专题，我们聊聊成人短剧里的视觉叙事。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20neon%20light%20streaks%20in%20deep%20crimson%20and%20charcoal%20reflecting%20on%20wet%20surface%2C%20film%20grain%2C%20moody%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=review-color-01&orientation=landscape',
    author: '视觉专栏 · 白薇',
    date: '2024-06-18',
    readTime: '6分钟',
    tags: ['视觉', '美学', '专题'],
    dramaId: 'beneath-neon',
    quote: '色彩不会说谎。它只是把角色藏在心里的话，翻译成了光。',
    content: [
      '在《霓虹之下》里，红色从来不只是装饰。它出现在危险将至的征兆里，也出现在情感失控的瞬间。导演用同一套色彩语言，把"危险"与"心动"巧妙地绑定在一起。',
      '这种视觉策略并不新鲜，但很少有短剧愿意如此系统地去执行。大多数作品把霓虹当作氛围滤镜，而《霓虹之下》把霓虹当成了叙事的一部分。',
      '冷与暖的对峙同样重要。当女记者走进调查现场时，画面转向冷调；而当她独自站在屋顶时，暖红又悄然回归。色温的变化，几乎等同于角色内心的天平。',
      '更重要的是，这套视觉系统始终服务于人物而非炫技。观众未必能说出"这是互补色对比"，但一定能感受到那种被包裹的不安与渴望。',
      '好的视觉叙事，从来不喧宾夺主。它安静地待在画面里，等你在某个瞬间忽然读懂。',
    ],
  },
  {
    id: 'last-subway-time-metaphor',
    title: '《最后一班地铁》的时间隐喻：相遇是一种倒计时',
    excerpt: '同一节车厢，不同的人生。这部剧用最日常的场景，完成了一次关于"错过"的哲学练习。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20empty%20subway%20platform%20at%20night%20with%20a%20single%20red%20signal%20light%2C%20deep%20charcoal%20tones%2C%20film%20grain%2C%20moody%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=review-subway-01&orientation=landscape',
    author: '影评人 · 江枫',
    date: '2023-02-09',
    readTime: '7分钟',
    tags: ['文艺', '叙事', '剧集解读'],
    dramaId: 'last-subway',
    quote: '每一趟末班车都在提醒我们：有些相遇，从开始就在倒计时。',
    content: [
      '《最后一班地铁》的设定简单到近乎朴素：两个陌生人在同一节车厢里反复相遇。但正是这种"日常感"，为整部剧提供了最坚实的情绪基础。',
      '地铁本身就是时间的隐喻。它按时刻表运行，不容迟疑，也不为任何人停留。两位主角每一次的"相遇"，本质上都是一次"即将分别"。这种矛盾，构成了剧集最动人的张力。',
      '导演沈屿很懂得节制。全剧几乎没有配乐煽情，而是让车轮声、报站声填满安静。当一段关系被放置在这样的背景音里，反而显得更加真实。',
      '两位演员的表演也值得称道。他们用一次次短暂的对视，累积出比台词更厚重的情感。成年人的靠近往往就是如此——不说破，不靠近，却在每一次对视里多走了一步。',
      '如果说大多数爱情故事在讲"如何在一起"，《最后一班地铁》讲的是"如何体面地错过"。而这份体面，正是成年世界最温柔的残酷。',
    ],
  },
];

export const reviewTagOptions: string[] = [
  '剧集解读',
  '情感',
  '都市',
  '女性',
  '行业观察',
  '题材探讨',
  '视觉',
  '文艺',
  '叙事',
  '专题',
];